import jwt_decode from 'jwt-decode';
import {routes} from "./routes/routes";

const TOKEN_KEY = 'kiln_token';
const CLAIM_KEY = 'kiln_claim';

function getStoredToken() {
    return localStorage.getItem(TOKEN_KEY);
}

function getStoredClaim() {
    try {
        const raw = localStorage.getItem(CLAIM_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function isTokenExpired(token) {
    try {
        const decoded = jwt_decode(token);
        return decoded.exp * 1000 < Date.now();
    } catch {
        return true;
    }
}

const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/dashboard\/?$/, '') || '';

const signIn = async ({username, password}, cb, onErrorCb) => {
    try {
        const response = await fetch(`${API_BASE}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: username, password }),
        });

        if (!response.ok) {
            const err = await response.json();
            if (onErrorCb) onErrorCb(err.error || 'Login failed');
            return;
        }

        const data = response.json ? await response.json() : {};
        const { token, claim } = data;

        localStorage.setItem(TOKEN_KEY, token);
        localStorage.setItem(CLAIM_KEY, JSON.stringify(claim));

        if (cb) cb(username, token, claim);
    } catch (err) {
        if (onErrorCb) onErrorCb(err.message || 'Login failed');
    }
};

export const signOut = (cb) => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(CLAIM_KEY);
    if (cb) cb();
};

// Initialize from localStorage
const storedToken = getStoredToken();
const storedClaim = getStoredClaim();
const isValid = storedToken && !isTokenExpired(storedToken);

const auth = {
    user: isValid ? storedClaim?.email || true : null,
    signIn,
    signOut,
    idToken: isValid ? storedToken : null,
    claim: isValid ? storedClaim : null,
};

export default auth;
